/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_Super_Admin_DescriptionInputs */



/**
* | output |
* | --- |
* | "They get full access to every organization, partner and commission. The invite link works once and expires in 24 hours — send it only to the person it is for." |
*
* @param {Partner_Admin_Invite_Super_Admin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_super_admin_description = /** @type {((inputs?: Partner_Admin_Invite_Super_Admin_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_Super_Admin_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Person erhält vollen Zugriff auf jede Organisation, jeden Partner und alle Provisionen. Der Einladungslink gilt einmalig und läuft nach 24 Stunden ab — senden Sie ihn nur an die vorgesehene Person.")
	return /** @type {LocalizedString} */ ("They get full access to every organization, partner and commission. The invite link works once and expires in 24 hours — send it only to the person it is for.")
});